// noinspection ES6ConvertVarToLetConst

/**
 * Fireworks only this version,
 * Support for multiple effects can be added
 */
var effects = {};

effects.on = false;

//Student API:
effects.turnOnFirework = function (send) {
  effects.on = true;
  effects.firework = new Fireworks();
  effects.onStart(send);
}
effects.turnOffFirework = function (send) {
  effects.on = false;
  effects.firework?.remove();
  delete effects.firework;
  effects.firework = null;
  effects.onEnd(send);
}
effects.toggleEffect = function (send) {
    if (effects.on) {
        effects.on = false;
        effects.firework.remove();
        delete effects.firework;
        effects.firework = null;
        effects.onEnd(send);
    }
    else {
        effects.on = true;
        effects.firework = new Fireworks();
        effects.onStart(send);
    }
};


function Fireworks() {

    'use strict';

    var whiteBoardCanvas = $('#whiteboardWrapper'),
        block = $('<canvas/>', {'id': 'firework-canvas'}),
        fireworksCanvas = block[0],
        ctx = fireworksCanvas.getContext('2d'),
        fireworks = [],
        particles = [],
        hue = 100,
        timerTotal = 5,
        timerTick = 0,
        cw,
        ch,
        reqAnimationFrame;


    this.init = function () {

        var $body = $('body');
        fireworksCanvas.width = $body.innerWidth();
        fireworksCanvas.height = whiteBoardCanvas.offset().top + whiteBoardCanvas.height();
        cw = fireworksCanvas.width;
        ch = fireworksCanvas.height + 150;

        block.css('position', 'absolute');
        block.css('z-index', '100');
        block.css('bottom', window.innerHeight - whiteBoardCanvas.offset().top - whiteBoardCanvas.height());
        $(block).click(function () {
            effects.onClickInFirework();
        });
        $body.addClass('show-fireworks');
        $body.append(block);
    };

    this.init();

    this.remove = function () {
        cancelAnimationFrame(reqAnimationFrame); // Cancels an animation frame request previously scheduled through a call to requestAnimationFrame()
        $('#firework-canvas').remove();
        block.remove();
        $('body').removeClass('show-fireworks');
    };

    // get a random number within a range
    function random(min, max) {
        return Math.random() * (max - min) + min;
    }

    // calculate the distance between two points
    function calculateDistance(p1x, p1y, p2x, p2y) {
        var xDistance = p1x - p2x,
            yDistance = p1y - p2y;
        return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
    }

    // create firework
    function Firework(sx, sy, tx, ty) {
        // actual coordinates
        this.x = sx;
        this.y = sy;
        // starting coordinates
        this.sx = sx;
        this.sy = sy;
        // target coordinates
        this.tx = tx;
        this.ty = ty;
        // distance from starting point to target
        this.distanceToTarget = calculateDistance(sx, sy, tx, ty);
        this.distanceTraveled = 0;
        // track the past coordinates of each firework to create a trail effect, increase the coordinate count to create more prominent trails
        this.coordinates = [];
        this.coordinateCount = 3;
        // populate initial coordinate collection with the current coordinates
        while (this.coordinateCount--) {
            this.coordinates.push([this.x, this.y]);
        }
        this.angle = Math.atan2(ty - sy, tx - sx);
        this.speed = 1.5;
        this.acceleration = 1.04;
        this.brightness = random(50, 70);
        // circle target indicator radius
    }

    // update firework
    Firework.prototype.update = function (index) {
        // remove last item in coordinates array
        this.coordinates.pop();
        // add current coordinates to the start of the array
        this.coordinates.unshift([this.x, this.y]);

        // speed up the firework
        this.speed *= this.acceleration;

        // get the current velocities based on angle and speed
        var vx = Math.cos(this.angle) * this.speed,
            vy = Math.sin(this.angle) * this.speed;
        // how far will the firework have traveled with velocities applied?
        this.distanceTraveled = calculateDistance(this.sx, this.sy, this.x + vx, this.y + vy);

        // if the distance traveled, including velocities, is greater than the initial distance to the target, then the target has been reached
        if (this.distanceTraveled >= this.distanceToTarget) {
            createParticles(this.tx, this.ty);
            // remove the firework, use the index passed into the update function to determine which to remove
            fireworks.splice(index, 1);
        }
        else {
            this.x += vx;
            this.y += vy;
        }
    };

    Firework.prototype.draw = function () {
        ctx.beginPath();
        // move to the last tracked coordinate in the set, then draw a line to the current x and y
        ctx.moveTo(this.coordinates[this.coordinates.length - 1][0], this.coordinates[this.coordinates.length - 1][1]);
        ctx.lineTo(this.x, this.y);
        ctx.strokeStyle = 'hsl(' + hue + ', 100%, ' + this.brightness + '%)';
        ctx.stroke();

        ctx.beginPath();
        // draw the target for this firework with a pulsing circle
        ctx.arc(this.tx, this.ty, 0, 0, Math.PI * 2);
        ctx.stroke();
    };

    // create particle
    function Particle(x, y) {
        this.x = x;
        this.y = y;
        // track the past coordinates of each particle to create a trail effect, increase the coordinate count to create more prominent trails
        this.coordinates = [];
        this.coordinateCount = 2;
        while (this.coordinateCount--) {
            this.coordinates.push([this.x, this.y]);
        }
        // set a random angle in all possible directions, in radians
        this.angle = random(0, Math.PI * 2);
        this.speed = random(1, 5);
        // friction will slow the particle down
        this.friction = 0.95;
        // gravity will be applied and pull the particle down
        this.gravity = 1;
        // set the hue to a random number +-50 of the overall hue variable
        this.hue = random(hue - 50, hue + 50);
        this.brightness = random(50, 80);
        this.alpha = 1;
        // set how fast the particle fades out
        this.decay = random(0.010, 0.02);
    }

    // update particle
    Particle.prototype.update = function (index) {
        // remove last item in coordinates array
        this.coordinates.pop();
        // add current coordinates to the start of the array
        this.coordinates.unshift([this.x, this.y]);
        // slow down the particle
        this.speed *= this.friction;
        // apply velocity
        this.x += Math.cos(this.angle) * this.speed;
        this.y += Math.sin(this.angle) * this.speed + this.gravity;
        // fade out the particle
        this.alpha -= this.decay;

        // remove the particle once the alpha is low enough, based on the passed in index
        if (this.alpha <= this.decay) {
            particles.splice(index, 1);
        }
    };

    // draw particle
    Particle.prototype.draw = function () {
        ctx.beginPath();
        ctx.arc(this.x, this.y, random(1, 2), 0, Math.PI * 2);
        ctx.strokeStyle = 'hsla(' + this.hue + ', 100%, ' + this.brightness + '%, ' + this.alpha + ')';
        ctx.fillStyle = 'hsla(' + this.hue + ', 100%, ' + this.brightness + '%, ' + this.alpha + ')';
        ctx.stroke();
        ctx.closePath();
        ctx.fill();
    };

    // create particle group/explosion
    function createParticles(x, y) {
        // increase the particle count for a bigger explosion, beware of the canvas performance hit with the increased particles though
        var particleCount = 30;
        while (particleCount--) {
            particles.push(new Particle(x, y));
        }
    }


    (function loop() {

        // this function will run endlessly with requestAnimationFrame
        reqAnimationFrame = requestAnimationFrame(loop);

        // increase the hue to get different colored fireworks over time
        //hue += 0.5;

        // create random color
        hue = random(0, 360);

        // normally, clearRect() would be used to clear the canvas
        // we want to create a trailing effect though
        // setting the composite operation to destination-out will allow us to clear the canvas at a specific opacity, rather than wiping it entirely
        ctx.globalCompositeOperation = 'destination-out';
        // decrease the alpha property to create more prominent trails
        ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
        ctx.fillRect(0, 0, cw, ch);
        // change the composite operation back to our main mode
        // lighter creates bright highlight points as the fireworks and particles overlap each other
        ctx.globalCompositeOperation = 'lighter';

        // loop over each firework, draw it, update it
        var i = fireworks.length;
        while (i--) {
            fireworks[i].draw();
            fireworks[i].update(i);
        }

        // loop over each particle, draw it, update it
        var i = particles.length;
        while (i--) {
            particles[i].draw();
            particles[i].update(i);
        }

        // launch fireworks automatically to random coordinates, when the mouse isn't down
        if (timerTick >= timerTotal) {
            fireworks.push(new Firework(cw / 2, ch, random(0, cw), random(0, ch / 2)));
            timerTick = 0;
        }
        else {
            timerTick++;
        }
    })()
}



